export default __webpack_public_path__ + "static/media/plate-check.d105bcb8.png";